import styled from 'styled-components';
import { FormControl, Box, InputLabel  } from '@mui/material';

import { Title } from '../../ui/Title';
import { Text32 } from '../../ui/Text32';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const WrapperHeader = styled.div``;

export const PageTitle = styled(Title)`
  margin-top: 64px;
`;

export const DataTouristWrapper = styled.div`
  width: 90%;
  max-width: 1400px;
  min-width: 320px;
`;

export const TouristWrapper = styled.div`
  margin-top: 120px;
`;

export const Header = styled.div`
  display: flex;
`;

export const TouristIcon = styled.img`
  height: 48px;
  width: 48px;
`;

export const TouristTitle = styled.h2`
  margin-left: 8px;
`;

export const Inputs = styled.div`
  margin-top: 48px;
`;

export const AllInputsWrapper = styled.div`
  display: flex;  

  @media (max-width: 1035px) {
    flex-direction: column;
  }
`;

export const SelectWrapper = styled(FormControl)` 
  width: 100%;  
`;

export const SelectBlock = styled(Box)`
  margin: 8px; 
  width: 33%;
  min-width: 33%; 
  @media (max-width: 1035px) {
    width: 100%;
    min-width: 100%; 
  }
`;

export const Label = styled(InputLabel)`
  background-color: white;
`;

export const ContinueWrapper = styled.div`
  width: 90%;
  max-width: 1400px;
  min-width: 320px;
  margin-top: 120px;
`;

export const AmountWrapper = styled.div`
  margin-bottom: 32px;
`;

export const AmountText = styled(Text32)``;

export const ButtonWrapper = styled.div`
  width: 300px;
`;